import React from 'react';

import { Box, Center, Wrap, WrapItem } from '@chakra-ui/react';
import map from 'lodash/map';

import { Tag } from 'app/components/DataDisplay/Tag';
import { TriangleDownIcon, TriangleUpIcon } from 'components/Icons';

export const formatTags = tags => (
  <Wrap>
    {map(tags, (each, index) => (
      <WrapItem key={index + 'tags'}>
        <Box>
          <Tag
            label={each.Key + ' : ' + each.Value}
            styles={{
              tag: {
                mb: 1,
                border: '1px solid',
                borderColor: 'primary',
              },
              label: {
                whiteSpace: 'normal',
              },
            }}
          />
        </Box>
      </WrapItem>
    ))}
  </Wrap>
);

export const collapseExpandIcon = isExpanded => {
  return (
    <Center boxSize={6} color="primary">
      {isExpanded ? <TriangleUpIcon /> : <TriangleDownIcon />}
    </Center>
  );
};
